/**
 * Enum for Access Levels
 * @readonly
 * @enum {name: {value: string}}
 */

export const AccessLevelEnum = Object.freeze({ disable: '1', viewonly: '2', editor: '3' });
